/*
 * Copyright © 2022 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Safe Html pipe.
 */
@Pipe({ name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform {
    /**
     * Pipe constructor.
     * 
     * @param sanitizer DomSanitizer.
     */
    constructor(private sanitizer: DomSanitizer) { }

    /**
     * Transform value, trust the given value to be safe HTML.
     * 
     * @param value Given value.
     * @returns SafeHtml.
     */
    transform(value: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }
}

/**
 * SortBy pipe.
 */
@Pipe({ name: 'sortBy' })
export class SortByPipe implements PipeTransform {

    /**
     * Sort data alphabetically.
     * 
     * @param array Array sorted.
     * @param order The direction in which to sort a list of items. Default is `asc`.
     * @param prop Property of item to compared.
     * @returns ComparatorResult.
     */
    transform(array: any[], order = 'asc', prop: string = 'label'): any[] {
        if (!array || order === '' || !order) { return array; }
        if (array.length <= 1) { return array; }
        return array.sort((a: any, b: any) => {
            let comparatorResult = 0;
            let valueA = (a[prop] || '').toLowerCase();
            let valueB = (b[prop] || '').toLowerCase();
            if (valueA > valueB) {
                comparatorResult = 1;
            } else if (valueA < valueB) {
                comparatorResult = -1;
            }
            return comparatorResult * (order === 'asc' ? 1 : -1);
        });
    }
}

/**
 * SortByCase pipe.
 */
@Pipe({ name: 'sortByCase' })
export class SortByCasePipe implements PipeTransform {

    /**
     * Sort data alphabetically.
     *
     * @param array Array sorted.
     * @param order The direction in which to sort a list of items. Default is `asc`.
     * @param prop Property of item to compared.
     * @returns ComparatorResult.
     */
    transform(array: any[], order = 'asc', prop: string = 'label'): any[] {
        if (!array || order === '' || !order) { return array; }
        if (array.length <= 1) { return array; }
        return array.sort((a: any, b: any) => {
            let comparatorResult = 0;
            let valueA = (a[0][prop] || '').toLowerCase();
            let valueB = (b[0][prop] || '').toLowerCase();
            if (valueA > valueB) {
                comparatorResult = 1;
            } else if (valueA < valueB) {
                comparatorResult = -1;
            }
            return comparatorResult * (order === 'asc' ? 1 : -1);
        });
    }
}
